import { useMemo } from 'react';
import { upperFirst } from 'lodash-es';
import { Box, Typography } from '@mui/material';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults as SEOSegmentationProviderSearchResult } from '@/__generated__/getSearchResults';
import shuffleProviderServices from '@/utils/shuffleProviderServices';

export interface ProviderServicesProps {
  attributes: SEOSegmentationProviderSearchResult['seniorAssistedLivingCenterAttributes'];
}

const ProviderServices = ({ attributes }: ProviderServicesProps) => {
  const services = useMemo(() => {
    const servicesList = shuffleProviderServices(attributes).map((service, idx) =>
      idx === 0 ? upperFirst(service) : service
    );

    if (servicesList.length >= 6) {
      return `${servicesList.join(', ')} & more`;
    }

    return servicesList.join(', ');
  }, [attributes]);

  if (!services.length) {
    return null;
  }
  return (
    <Box alignItems="center" mt={1.5}>
      <Typography component="span" variant="body2" fontWeight="700">
        Services:{' '}
      </Typography>
      <Typography component="span" variant="body2" fontStyle="italic">
        {services}
      </Typography>
    </Box>
  );
};

export default ProviderServices;
